{
  "messages": {
    "loading": "Chargement des messages...",
    "empty": "Aucun message pour le moment. Commencez la conversation !",
    "noEntitiesSelected": "Veuillez sélectionner des entités dans le menu déroulant ci-dessus pour voir les messages.",
    "counter": "Messages / {{count}}",
    "reply": "Répondre",
    "replyPlaceholder": "Écrivez une réponse...",
    "replyPlaceholderInternal": "Écrivez une réponse interne...",
    "replyPlaceholderClient": "Écrivez une réponse visible pour les clients...",
    "cancel": "Annuler",
    "send": "Envoyer",
    "important": "Important",
    "scrollToBottom": "Faire défiler vers le bas",
    "refresh": "Actualiser les messages"
  },
  "tabs": {
    "internal": "Interne",
    "client": "Client", 
    "all": "Tout"
  },
  "visibility": {
    "client": "Client"
  },
  "thread": {
    "reply": "réponse",
    "replies": "réponses"
  },
  "filters": {
    "relatedEntities": "Entités liées",
    "selectEntities": "Sélectionner des entités",
    "selectEntitiesDescription": "Voir les messages de plusieurs entités",
    "selectEntitiesPlaceholder": "Sélectionner des entités...",
    "all": "Tout",
    "current": "Actuel",
    "typesSelected": "{{count}} types sélectionnés",
    "important": "Important",
    "showImportant": "Afficher Important",
    "showImportantOnly": "Afficher uniquement les messages importants",
    "showAllMessages": "Afficher tous les messages"
  },
  "input": {
    "placeholder": "Écrivez un message...",
    "placeholderAllTab": "Passez à l'onglet Interne ou Client pour envoyer des messages",
    "placeholderInternal": "Écrivez une mise à jour interne...",
    "placeholderClient": "Écrivez un message visible pour les clients...",
    "warningNote": "Note :",
    "warningMessage": "Sélectionnez l'entité actuelle ({{entityKey}}) pour envoyer des messages."
  },
  "emoji": {
    "title": "Ajouter un emoji",
    "popoverTitle": "Insérer un emoji",
    "categories": {
      "Smileys": "Émoticônes",
      "Gestures": "Gestes",
      "Objects": "Objets", 
      "Symbols": "Symboles"
    }
  },
  "tooltips": {
    "mentions": "@Mentions bientôt disponibles !",
    "attachments": "Pièces jointes bientôt disponibles !",
    "bold": "Gras",
    "italic": "Italique",
    "underline": "Souligné",
    "numberedList": "Liste numérotée",
    "bulletList": "Liste à puces",
    "link": "Lien",
    "showFormatting": "Afficher le formatage",
    "hideFormatting": "Masquer le formatage",
    "insertEmoji": "Insérer un emoji",
    "sendMessage": "Envoyer le message (Ctrl+Entrée)",
    "enterUrl": "Saisissez l'URL :",
    "addLink": "Ajouter un lien",
    "linkText": "Texte du lien",
    "markAsImportant": "Marquer comme important",
    "markAsNormal": "Retirer l'importance",
    "migrated": "Migré",
    "important": "Important"
  },
  "time": {
    "justNow": "à l'instant",
    "minuteAgo": "il y a {{count}} minute",
    "minutesAgo": "il y a {{count}} minutes",
    "hourAgo": "il y a {{count}} heure",
    "hoursAgo": "il y a {{count}} heures", 
    "dayAgo": "il y a {{count}} jour",
    "daysAgo": "il y a {{count}} jours",
    "monthAgo": "il y a {{count}} mois",
    "monthsAgo": "il y a {{count}} mois",
    "yearAgo": "il y a {{count}} an",
    "yearsAgo": "il y a {{count}} ans"
  },
  "accessibility": {
    "closeChatPanel": "Fermer le panneau de chat",
    "openChat": "Ouvrir le chat"
  }
}
